/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { RibbonProps } from 'antd/es/badge/Ribbon'

export type BannerInfoRecord = Record<string, BannerInfo>
export interface BannerInfo {
  text: string
  color: RibbonProps['color']
}

export const BANNER_INFO_RECORD: BannerInfoRecord = {
  DEV: {
    text: 'Dev',
    color: '#F5222D' // red6
  },
  STAGING: {
    text: 'Staging',
    color: '#389E0D' // green7
  }
}
